
import { defineComponent } from 'vue';
import numeral from 'numeral';
import {
  getShoppingcartPage,
  submitImportOrder,
  getImportTotalPrice
} from '@/api/apis';

export default defineComponent({
  name: 'UploadModal',
  data() {
    return {
      numeral,
      visible: true,
      columns: [
       {
          title: this.$t('shopping_cart.vehicle_name'),
          dataIndex: 'vehicleName',
          width: 100,
          slots: { title: 'pvehicle_name-title', customRender: 'vehicleName' }
        },
        {
          title: this.$t('shopping_cart.sc_part_type'),
          dataIndex: 'groupName',
          width: 100,
          slots: { customRender: 'groupName' }
        },
        {
          title: this.$t('shopping_cart.sc_name'),
          dataIndex: 'name',
          width: 100,
          slots: { customRender: 'name' }
        },
        {
          title: this.$t('shopping_cart.sc_part_no'),
          dataIndex: 'modelNum',
          width: 120
        },
        {
          title: this.$t('shopping_cart.sc_part_code'),
          dataIndex: 'partCode',
          width: 100
        },
        {
          title: this.$t('shopping_cart.sc_unit'),
          dataIndex: 'unit',
          width: 100,
          slots: { customRender: 'unit' }
        },
        {
          title: this.$t('shopping_cart.sc_quantity'),
          dataIndex: 'quantity',
          width: 100
        },
        // {
        //   title: this.$t('shopping_cart.sc_unit_price'),
        //   dataIndex: 'unitPrice',
        //   width: 100,
        //   slots: { customRender: 'unitPrice' }
        // },
        // {
        //   title: this.$t('shopping_cart.sc_total_price'),
        //   dataIndex: 'totalPrice',
        //   width: 100,
        //   slots: { customRender: 'totalPrice' }
        // },
        {
          title: this.$t('shopping_cart.sc_consignee'),
          dataIndex: 'consignee',
          width: 100
        },
        {
          title: this.$t('shopping_cart.sc_remark'),
          dataIndex: 'remark',
          width: 120
        }
      ],
      summaryTotal: null,
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSizeOptions: ['5', '10', '15'],
        total: 0,
        showSizeChanger: true,
        pageSize: 5,
        showQuickJumper: true
        // size: 'large'
      }
    };
  },
  created() {
    this.loadData();

    this.getTotalPrice();
  },
  emits: ['after-close'],
  methods: {
    async getTotalPrice() {
      const res = await getImportTotalPrice();

      if (res.success) {
        this.summaryTotal = res.result;
      }
    },
    async loadData() {
      this.loading = true;
      const res = await getShoppingcartPage({
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        shoppingType: '3' // 从文件上传的数据
      });

      if (res.success) {
        this.dataSource = res.result.records || [];

        this.ipagination.total = res.result.total || 0;
      }

      this.loading = false;
    },
    handleAfterClose() {
      this.$emit('after-close');
    },
    handleTableChange(pagination) {
      this.ipagination = pagination;

      this.loadData();
    },
    onShowSizeChange(current) {
      this.ipagination.current = current;

      this.loadData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;

      this.loadData();
    },
    async handleSubmitOrder() {
      this.loading = true;
      const res = await submitImportOrder();

      if (res.success) {
        this.visible = false;
      }

      this.loading = false;
    }
  }
});
